<button class="loading-grey-btn" mat-raised-button color="primary" type="button">
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</button>
